import {
  legacy_createStore as createStore,
  applyMiddleware,
  Middleware,
  Store,
  UnknownAction,
} from 'redux';
import { thunk, ThunkDispatch, ThunkMiddleware } from 'redux-thunk';
import rootReducer, { RootState, resetState, BasicAction } from './rootReducer';
import Auth from './Auth';
import { sessionExpired } from './factory/login/sessionReducer';
import type { NavigateFunction } from 'react-router-dom';

const createJwtMiddleware = (
  navigate: NavigateFunction
): Middleware<{}, RootState, ThunkDispatch<RootState, undefined, BasicAction>> => {
  return (storeAPI) => (next) => (action: any) => {
    if (typeof action === 'function' && Auth.isTokenExpired()) {
      Auth.deauthenticateUser();

      const dispatch = storeAPI.dispatch as ThunkDispatch<
        RootState,
        undefined,
        BasicAction
      >;

      dispatch(resetState());
      dispatch(sessionExpired(navigate));

      return action;
    }

    return next(action);
  };
};

export function configureAppStore(
  navigate: NavigateFunction
): Store<RootState, BasicAction> & {
  dispatch: ThunkDispatch<RootState, undefined, BasicAction>;
} {
  const jwtMiddleware = createJwtMiddleware(navigate);

  const store = createStore(
    rootReducer,
    applyMiddleware(
      thunk as unknown as ThunkMiddleware<RootState, BasicAction>,
      jwtMiddleware
    )
  );

  return store;
}

export type AppDispatch = ReturnType<typeof configureAppStore>['dispatch'];
export type AppRootState = RootState;
